import React from "react"
import malarAiImagePath from "../../img/malar_ai.jpeg"
import malarAiImagePath2 from "./images/malarAI-image1.png"
import malarAiImagePath3 from "./images/malarAI-image2.png"
import "./MalarAI.css"
import ProjectCard from "../../ProjectCard"

function MalarAI() {
  return (
    <div className="DetailsPage">
      <h1 className="project-details-heading">Malar-AI</h1>
      <div className="all-details">
        <ProjectCard
          animType1={window.innerWidth <= 400 ? "fade-up" : "fade-right"}
          animType2="flip-left"
          content="Malar-AI is a handy device detect probable malaria infection using blood smear slides. Powered by ResNet-50, cell-phone microscope and a staining kit, this setup is capable of performing at an accuracy of >95%. Enhances the ease of Malaria testing in areas where the availability of testing equipments is not adequate."
          imgUrl={malarAiImagePath}
          name="Malar-AI"
          showKnowMore="false"
        />

        <section className="githubRepoSection" data-aos="fade-up">
          <h1 data-aos="fade-up">Github Repositories</h1>

          <div className="repos">
            <a
              className="repoLink"
              href="https://github.com/dasari810/Malar-Ai"
              target="blank"
            >
              <button type="button" className="btn btn-outline-light">
                Link 1
              </button>
            </a>
            <a
              className="repoLink"
              href="https://github.com/vishantbatta/Malar-Ai-Malaria-detection-using-deep-learning-models-on-blood-smear-slide"
              target="blank"
            >
              <button type="button" className="btn btn-outline-light">
                Link 2
              </button>
            </a>
          </div>
        </section>

        <section className="imageSection" data-aos="fade-up">
          <h1 data-aos="fade-up">Images</h1>

          <div className="images">
            <img
              className="image"
              src={malarAiImagePath2}
              alt=""
              height="150px"
              width="150px"
            />
            <img
              className="image"
              src={malarAiImagePath3}
              alt=""
              height="150px"
              width="150px"
            />
          </div>
        </section>

        <section className="contributorsSection" data-aos="fade-up">
          <h1 data-aos="fade-up">Contributors</h1>

          <div className="contributors">
            <div className="contributor" data-aos="fade-up">
              <div className="contributorName">
                <span>Dasari</span>
                <span className="contributorNameSpace">&nbsp;</span>
                <span>Madhava</span>
              </div>

              <a href="https://github.com/dasari810" target="blank">
                <button type="button" className="btn btn-outline-light">
                  Github
                </button>
              </a>
            </div>

            <div className="contributor" data-aos="fade-up">
              <div className="contributorName">
                <span>Vishant</span>
                <span className="contributorNameSpace">&nbsp;</span>
                <span>Batta</span>
              </div>

              <a href="https://github.com/vishantbatta" target="blank">
                <button type="button" className="btn btn-outline-light">
                  Github
                </button>
              </a>
            </div>

            <div className="contributor" data-aos="fade-up">
              <div className="contributorName">
                <span>Rohan</span>
                <span className="contributorNameSpace">&nbsp;</span>
                <span>N</span>
              </div>

              <a href="https://github.com/nrohan09-cloud" target="blank">
                <button type="button" className="btn btn-outline-light">
                  Github
                </button>
              </a>
            </div>

            <div className="contributor" data-aos="fade-up">
              <div className="contributorName">
                <span>OV</span>
                <span className="contributorNameSpace">&nbsp;</span>
                <span>Srikanth</span>
              </div>

              <a href="https://github.com/OVSRIKANTH" target="blank">
                <button type="button" className="btn btn-outline-light">
                  Github
                </button>
              </a>
            </div>

            <div className="contributor" data-aos="fade-up">
              <div className="contributorName">
                <span>Tanay</span>
                <span className="contributorNameSpace">&nbsp;</span>
                <span>Kohale</span>
              </div>

              <a href="https://github.com/tanaykohale" target="blank">
                <button type="button" className="btn btn-outline-light">
                  Github
                </button>
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default MalarAI
